import { AuthContextInterface, withAuthContext } from '@amzn/awscat-react-components';
import { ButtonDropdown, ButtonDropdownProps } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';
import { coreResources } from '../../common/resourceConstants';

type ResourceDropdownPros = AuthContextInterface & {isAuthenticated: boolean};

function ResourcesDropdown(props: ResourceDropdownPros): JSX.Element | null {
    const dropdownItems: ButtonDropdownProps.ItemOrGroup[] = coreResources.map(resource => ({
        id: resource.id,
        text: resource.text,
        href: resource.href,
        external: true,
    }));
    dropdownItems.push({id: 'whatsnew', text: constants.WHATS_NEW, href: '/whats-new', external: true});

    return props.isAuthenticated ? (
        <ButtonDropdown expandToViewport variant='normal' items={dropdownItems}>Resources</ButtonDropdown>
    ) : null;
}

export default withAuthContext(ResourcesDropdown);
